// TableScroll — marks a `.table-scroll` wrapper once it has been scrolled
// horizontally so the sticky first column can show an edge shadow (see
// app.css). Also gives the region keyboard focus semantics.
export default {
  mounted() {
    const el = this.el
    const update = () => el.toggleAttribute("data-scrolled", el.scrollLeft > 0)
    el.addEventListener("scroll", update, {passive: true})
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "0")
    update()
  },
}
